<template>
  <div class="month-cont">
    <div class="flex month-nav-cont align-center">
      
      <ButtonCompVue
        class=""
        ref="prevMonth"
        label="<i class='material-symbols-outlined'>arrow_back</i>"
        @btn-click="onClickPrev"
        type="invisible"
        size="btn-small" />
      <ButtonCompVue
        class=""
        ref="nextMonth"
        label="<i class='material-symbols-outlined'>arrow_forward</i>"
        @btn-click="onClickNext"
        type="invisible"
        size="btn-small" />
  
      <ButtonCompVue
        class="btn-small"
        ref="today"
        label="Today"
        @btn-click="onClickToday"
        type="outline"
        size="btn-small" />

      <div class="month-name">
        <h2>{{monthName}}</h2>
      </div>
    </div>

    <CalendarVue :year="year" :month="month"></CalendarVue>
  </div>
</template>

<script>
//import CalendarVue from './Calendar'
import CalendarVue from '@Common/components/CalendarCompVue'

import ButtonCompVue from '@Common/components/ButtonCompVue'
import calendar from '@Common/utils/calendar_helpers'

import { useRouter } from 'vue-router'

export default {
  name: 'MonthVue',

  setup() {
    const router = useRouter()
    return {
      router,
    }
  },

  props: {
    month: Number,
    year: Number,
  },

  data() {
    return {
      today: new Date(),
    }
  },

  computed: {
    // get a 0 based indexed month number
    monthNum() {
      if (this.month) {
        return parseInt(this.month - 1)
      }
      return this.today.getMonth()
    },

    // 0 indexed months array for js
    monthName() {
      return calendar.MONTHS[this.monthNum].name
    },
  },

  methods: {
    onClickPrev() {
      let month = this.month - 1
      let year = this.year
      if (month === 0) {
        year -= 1
        month = 12
      }
      this.router.push({
        name: 'monthly',
        params: {
          month,
          year,
        }
      })
    },

    onClickNext() {
      let month = this.month + 1
      let year = this.year
      if (month === 13) {
        year += 1
        month = 1
      }
      this.router.push({
        name: 'monthly',
        params: {
          month,
          year,
        }
      })
    },

    onClickToday() {
      const month = this.today.getMonth() + 1 // 0 based indexing
      const year = this.today.getFullYear()
      this.router.push({
        name: 'monthly',
        params: {
          month,
          year,
        }
      })
    }
  },

  created() {
  },

  components:{
    ButtonCompVue,
    CalendarVue,
  }
}

</script>

<style lang="scss" scoped>
.month-cont {
  height: 100%;
  
  .month-nav-cont {
    .btn-cont {
      padding: 0 $padding;
    }

    .month-name {
      h2 {
        font-size: $font-large;
      }
    }
  }
}
</style>
